module.exports = __webpack_public_path__ + "static/gh-rough-89d5a06cbf827c2dc1678d9d755b1428.jpg";